// ============================================================================
// Perfiles de la plataforma
// ----------------------------------------------------------------------------
// El perfil se deriva de usuario.id_rol vía el SP GetTicket → ticket.Retorno:
//   Retorno 1  = evaluado            (id_rol 1)
//   Retorno 2  = admin institución   (id_rol 2)
//   Retorno 3  = superusuario        (id_rol 3)
//
// Admin (perfil 2 o 3) accede a los reportes y a la ficha del evaluado.
// Superusuario (perfil 3) además ve el detalle pregunta a pregunta de la ficha.
// ============================================================================

// Admin: perfil 2 o 3 (Retorno 2 o 3).
export const esAdmin = (ticket) =>
  !!ticket && (ticket.Retorno == 2 || ticket.Retorno == 3);

// Superusuario: perfil 3 (Retorno 3).
export const esSuperadmin = (ticket) => !!ticket && ticket.Retorno == 3;
